import { dialogRegistry, IDialogRegistration } from '@microsoft/portal-app/lib/Notifications/dialogRegistry';
import * as React from 'react';

import { addReducer } from '../../redux/modules/root';
import { IDevicesState, IRootDevicesState } from '../models';
import { DevicesActions, devicesRegistry, IDevicesAction } from '../redux';
import { getTelemetry } from '../../Telemetry/Telemetry';

/**
 * This module contains the ability to route to the bitLockerKeyPanel and for it be able to show in the left nav menu.
 * @description Registers routes to UI components, links, and business logic/state management in the form of reducers
 */

export const AsyncConnectedBitLockerKeyPanel = React.lazy(() =>
  import('./ConnectedBitLockerKeyPanel')
    .then((loaded) => ({
      default: loaded.ConnectedbitLockerKeyPanel,
    }))
    .catch((err) => {
      const telemetry = getTelemetry();
      telemetry.error('resourceError/AsyncConnectedBitLockerKeyPanel', `Failed to get bundle ${err}`);
      throw err;
    }),
);

dialogRegistry.addDialog({
  component: AsyncConnectedBitLockerKeyPanel,
  dialogAction: DevicesActions.showBitLockerKeys,
} as IDialogRegistration);

addReducer<IRootDevicesState, IDevicesState, IDevicesAction>('devices', devicesRegistry);
